import React from "react";
import { Link } from "react-router-dom";

const COPY = {
  privacy: {
    title: "Privacy",
    body: [
      "We read your CRM and email metadata to draft replies. Read-only.",
      "We never sell, share, or train on your data.",
      "All data lives in encrypted Postgres in US-East with daily snapshots.",
      "Full data export and hard delete available on email request — 24-hour turnaround.",
    ],
  },
  terms: {
    title: "Terms of service",
    body: [
      "You own everything we draft for you. Every word.",
      "We never message your customers. Not text, not call, not email.",
      "Auto-refund triggers on missed SLA — no support ticket required.",
      "Either side can terminate with 30 days notice. No exit interview.",
    ],
  },
  aup: {
    title: "Acceptable use",
    body: [
      "Don't use LeadRiver to draft harassment, spam, or anything you wouldn't sign your name to.",
      "Don't use LeadRiver to evade TCPA or CAN-SPAM by adding outbound channels yourself.",
      "Don't share access with vendors not bound by your customer agreements.",
      "Violations end the relationship the same day, no refund pro-rate beyond unused service.",
    ],
  },
};

export default function LegalPage({ slug }) {
  const c = COPY[slug];
  if (!c) return null;
  return (
    <main className="min-h-[80svh] max-w-3xl mx-auto px-6 pt-36 pb-24" data-testid={`legal-${slug}`}>
      <p className="kicker">Legal</p>
      <h1 className="h-section text-[clamp(2rem,4vw,3rem)] mt-4">{c.title}</h1>
      <ul className="mt-10 space-y-5">
        {c.body.map((p) => (
          <li
            key={p}
            className="font-serif-body text-[1.1rem] leading-relaxed text-[#1A1A1A] border-t border-[#E5E0D8] pt-5"
          >
            {p}
          </li>
        ))}
      </ul>
      <p className="font-serif-body text-[#4A4A4A] mt-10 text-[14px]">
        These pages are plain-English summaries. Full legal text drops with the
        first paying customer. Email legal@leadriver.ai for redlines.
      </p>
      <Link to="/" className="btn btn-ghost mt-10">← Back to leadriver.ai</Link>
    </main>
  );
}
